import { Commodity } from './commodity';
import { Variety } from './variety';
import { ExternalResource } from './externalResource';

export class Product {
  id: number;
  companyId?: number;
  type?: string;
  name?: string;
  description?: string;
  registerNumber?: string | number;
  status?: string;
  producerName?: string;
  packageLabelUrl?: string;
  commodity?: string; // Solo il nome della commodity
  commodityObj?: Commodity;
  varietyObj?: Variety;
  azotoPercentage?: number; // SOLO Per 2. Nutrizione
  phosphorusPercentage?: number; // SOLO Per 2. Nutrizione
  potassiumPercentage?: number; // SOLO Per 2. Nutrizione
  dangerInfos?: string; // SOLO Per 1. Difesa
  activity?: string; //  per cosa viene usato questo prodotto
  activeSubstance?: string; // SOLO Per 1. Difesa
  composition?: string; // SOLO Per 1. Difesa
  contentPer100g?: string; // SOLO Per 1. Difesa
  growingCycleDays?: number; // SOLO 4.3 Seminare Livello 2 di 4. Operazione (Livello 1)
  faoClass?: string; // SOLO 4.3 Seminare Livello 2 di 4. Operazione (Livello 1)
  subType?: string;
  bioUse?: boolean;
  countryOrigin?: string;
  bullOrigin?: string;
  numADL?: number;
  numNDF?: number;
  numADF?: number;
  numProtein?: number;
  numStarchSugar?: number;
  numGrease?: number;
  dryMatter?: number;
  drySubstancePercentage?: number;
  modeOfAction?: string;
  statusTranslate?: string;
  country?: string;
  extraUpdate?: Date;
  nameAndregisterNumber?: string; //only FE
  itemName?: string;
  nutrients?: string[];
  noDeforestationImpact?: boolean;
  varietyName?: string;
  co2eqImpact?: number;
  externalResources?: Array<ExternalResource> = [];
  category?: string;
  seedsCuredProducer?: any;
  numAsh?: number;
  numFiber?: number;
  typology?: string;
  actualDose?: number;
  isSelectable?: boolean;

  constructor() {
    this.id = undefined;
    this.type = undefined;
    this.name = undefined;
    this.description = undefined;
    this.registerNumber = undefined;
    this.status = undefined;
    this.producerName = undefined;
    this.packageLabelUrl = undefined;
    this.commodity = undefined; // Solo il nome della commodity
    this.commodityObj = undefined;
    this.varietyObj = undefined;
    this.azotoPercentage = undefined; // SOLO Per 2. Nutrizione
    this.phosphorusPercentage = undefined; // SOLO Per 2. Nutrizione
    this.potassiumPercentage = undefined; // SOLO Per 2. Nutrizione
    this.dangerInfos = undefined; // SOLO Per 1. Difesa
    this.activity = undefined; // per cosa viene usato questo prodotto
    this.activeSubstance = undefined; // SOLO Per 1. Difesa
    this.composition = undefined; // SOLO Per 1. Difesa
    this.contentPer100g = undefined; // SOLO Per 1. Difesa
    this.growingCycleDays = undefined; // SOLO 4.3 Seminare Livello 2 di 4. Operazione (Livello 1)
    this.faoClass = null;
    this.subType = undefined;
    this.bioUse = false;
    this.countryOrigin = undefined;
    this.bullOrigin = undefined;
    this.numADL = undefined;
    this.numNDF = undefined;
    this.numADF = undefined;
    this.numProtein = undefined;
    this.numStarchSugar = undefined;
    this.numGrease = undefined;
    this.drySubstancePercentage = undefined;
    this.modeOfAction = undefined;
    this.statusTranslate = undefined;
    this.country = undefined;
    this.extraUpdate = undefined;
    this.nameAndregisterNumber = undefined;
    this.nutrients = undefined;
    this.noDeforestationImpact = false;
    this.varietyName = undefined;
    this.category = undefined;
    this.seedsCuredProducer = undefined;
    this.numAsh = undefined;
    this.numFiber = undefined;
    this.typology = undefined;
    this.actualDose = undefined;
    this.isSelectable = true;
  }
}

/*
*********** MODELLO DI BACKEND **********************

package com.xfarm.api.v1.lists

import com.xfarm.api.v1.auth.User
import com.xfarm.api.v1.core.FieldActivity

class Product {
    transient springSecurityService

    Long    companyId = -1
    string  type
    string  name
    string  description
    string  registerNumber
    string  producerName
    string  packageLabelUrl
    string  commodity               // Solo il nome della commodity

    Integer azotoPercentage         // SOLO Per 2. Nutrizione
    Integer phosphorusPercentage    // SOLO Per 2. Nutrizione
    Integer potassiumPercentage     // SOLO Per 2. Nutrizione

    string  dangerInfos             // SOLO Per 1. Difesa
    string  activity                // SOLO Per 1. Difesa - per cosa viene usato questo prodotto
    string  activeSubstance       // SOLO Per 1. Difesa
    string  composition             // SOLO Per 1. Difesa
    string  contentPer100g          // SOLO Per 1. Difesa

    Integer growingCycleDays        // SOLO 4.3 Seminare Livello 2 di 4. Operazione (Livello 1)
    string  faoClass                // SOLO 4.3 Seminare Livello 2 di 4. Operazione (Livello 1)

    static constraints = {
        companyId               blank: false
        type                    blank: false, nullable:false, inList: ["seeds", "chemicals", "fertilizers"]
        name                    blank: false, nullable:false
        description             blank: false, nullable:true
        registerNumber          blank: false, nullable:true
        producerName            blank: false, nullable:true
        packageLabelUrl         blank: false, nullable:true, url:true
        commodity               blank: false, nullable:true
        azotoPercentage         nullable:true
        phosphorusPercentage    nullable:true
        potassiumPercentage     nullable:true
        dangerInfos             blank: false, nullable:true
        activity                blank: false, nullable:true
        activeSubstance         blank: false, nullable:true
        composition             blank: false, nullable:true
        contentPer100g          nullable:true
        growingCycleDays        nullable:true
        faoClass                blank: false, nullable:true
    }


    def beforeInsert() {
        if(springSecurityService?.principal?.authorities?.role?.contains('ROLE_XFARM_SUPER_BOSS_JHK?hj89K09#wY45')){
            companyId = -2
        } else {
            companyId = User.get(springSecurityService?.principal?.id)?.farm?.id
        }

    }

    def beforeUpdate() {
        if(companyId != User.get(springSecurityService?.principal?.id)?.farm?.id){
            return false
        }
    }

    static transients = ['springSecurityService']
}

*/
